import React from 'react';
import PropTypes from 'prop-types';
import InvoiceTextField from '../../../../InvoiceTextField';
import { otherFieldsRows, uneditableFields } from '../InvoiceLineFieldsHelper';
import ArrowExpandButton from '../../arrowExpandButton/ArrowExpandButton';

const inputsColumnStyle = { display: 'flex', width: '47.6%', marginLeft: '4.4%' };
const firstColumnStyle = { display: 'flex', width: '48%' };

class InvoiceLineOtherFieldsSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = { collapsed: true };
  }

  render() {
    const { invoiceLineData } = this.props;
    const { collapsed } = this.state;
    return (
      <React.Fragment>
        <div style={ { display: 'flex' } }>
          <ArrowExpandButton
            collapsed={ collapsed }
            onExpand={ () => this.setState({ collapsed: false }) }
            onCollapse={ () => this.setState({ collapsed: true }) }
            style={ { margin: '2px 5px 0 0' } }
          />
          <h1 className="invoice-line-section-title">All other fields</h1>
        </div>
        {
          !collapsed &&
          otherFieldsRows.map((row, rowIndex) => (
            <div style={ { display: 'flex', flex: 1, marginBottom: 10 } } key={ rowIndex }>
              {
                row.map((field, fieldIndex) => (
                  <div key={ field.key } style={ fieldIndex === 0 ? firstColumnStyle : inputsColumnStyle }>
                    <InvoiceTextField
                      name={ field.key }
                      label={ field.label }
                      value={ invoiceLineData[field.key] }
                      onChange={ (ev, value, errorMessage) => this.props.onFieldChange(ev, value, errorMessage) }
                      fullWidth={ true }
                      disabled={ uneditableFields.some(uneditableField => uneditableField === field.key) }
                      dataType={ field.dataType }
                      stringMaxLength={ field.stringMaxLength || '' }
                    />
                  </div>
                ))
              }
            </div>
          ))
        }
      </React.Fragment>
    );
  }
}

InvoiceLineOtherFieldsSection.propTypes = {
  invoiceLineData: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  collapsed: PropTypes.bool.isRequired
};

export default InvoiceLineOtherFieldsSection;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceLinesDetail/c/invoiceLineEditor/invoiceLineEditorSections/InvoiceLineOtherFieldsSection.js